import { flow, types } from "mobx-state-tree";
import orgAPI from "./OrgService";

export const OrganizeDashboardModel = types
    .model("OrganizeDashboardModel", {
        "Develop Environment": types.maybeNull(types.number),
        "รัฐวิสาหกิจ": types.maybeNull(types.number),
        "หน่วยงานเอกชน": types.maybeNull(types.number),
        "หน่วยงานรัฐ": types.maybeNull(types.number),
    })
    .actions((self: any) => ({
        getOrgDashboard: flow(function*() {
            try {
                const result = yield orgAPI.getOrgDashboard();
                self.setAllField(result.data);
            } catch (e) {
                throw e;
            } finally {
                //
            }
        }),
        setAllField: (data: any) => {
            Object.keys(data).forEach((key) => {
                self[key] = data[key];
            });
        },
    }));

export type IOrganizeDashboardModel = typeof OrganizeDashboardModel.Type;
